import type { ReactElement } from "react";
import { Icon } from "@chakra-ui/react";
import type { IconProps } from "@chakra-ui/react";

const SquarespaceLogo = ({
  color = "#000",
  ...props
}: IconProps): ReactElement => (
  <Icon viewBox="0 0 128 128" color={color} {...props}>
    <title>Squarespace Logo</title>
    <circle cx={64} cy={64} r={64} fill="currentColor" />
    <path
      fill="#fff"
      d="M36.328 65.89l29.468-29.47a10.543 10.543 0 017.506-3.104c2.837 0 5.502 1.101 7.502 3.102l2.296 2.296 4.593-4.592-2.297-2.296c-3.224-3.226-7.52-5.002-12.096-5.002-4.574 0-8.87 1.777-12.096 5.004L31.736 61.297l4.592 4.592z"
    />
    <path
      fill="#fff"
      d="M75.664 46.15l-4.592-4.591-29.469 29.468c-4.139 4.138-10.87 4.139-15.008.002-4.138-4.139-4.138-10.872 0-15.01l25.427-25.427-4.592-4.593-25.427 25.427c-6.67 6.67-6.67 17.525 0 24.195a16.99 16.99 0 0012.094 5.002c4.575 0 8.872-1.777 12.099-5.004l29.468-29.468zm29.333 5.277a16.99 16.99 0 00-12.096-5.002 16.992 16.992 0 00-12.097 5.004L51.336 80.897l4.592 4.593 29.469-29.47c4.139-4.138 10.871-4.137 15.008-.002a10.542 10.542 0 013.103 7.505c0 2.84-1.102 5.505-3.103 7.506L74.978 96.457l4.592 4.592 25.427-25.427c6.671-6.67 6.671-17.525 0-24.195z"
    />
    <path
      fill="#fff"
      d="M90.672 61.16L61.204 90.628c-4.139 4.138-10.87 4.139-15.008.003L43.9 88.334l-4.593 4.593 2.296 2.295c3.225 3.226 7.52 5.002 12.097 5.002 4.574 0 8.87-1.777 12.096-5.004l29.469-29.467-4.593-4.593z"
    />
  </Icon>
);

export default SquarespaceLogo;
